export interface Category {
  type?: 'GAME' | 'ETC' | string
  id?: string
  text: string
}
